import type { Fallacy } from "./types";
import { createStory } from "./types";

export const ecologicalFallacy: Fallacy = {
    id: "ecological-fallacy",
    name: "Ecological Fallacy",
    emoji: "🌐",
    category: "Manipulasi Statistik",
    description: "Menyimpulkan sifat **individu** berdasarkan **statistik agregat** kelompoknya.",
    tldr: "Rata-rata gajinya tinggi, berarti semua orangnya kaya — belum tentu!",
    detail: "Ecological Fallacy terjadi ketika seseorang menyimpulkan **karakteristik individu** berdasarkan **data agregat kelompok**. Hanya karena sebuah kelompok memiliki rata-rata tertentu, tidak berarti setiap anggotanya memiliki karakteristik yang sama.\n\nContoh: rata-rata pendapatan per kapita Jakarta Rp 250 juta per tahun. Bukan berarti setiap warga berpenghasilan segitu — angka ini ditarik naik oleh segelintir orang ultra-kaya, sementara mayoritas berpenghasilan jauh di bawahnya.\n\nIngat: **statistik kelompok menggambarkan kelompok, bukan individu-individu** di dalamnya. Variasi di dalam kelompok sering kali lebih besar daripada variasi antar kelompok.",
    story: createStory("Ecological Fallacy", "🌐", {
      hook: {
        title: "\"Lulusan TI gajinya 15 juta!\"",
        body: "Berarti semua lulusan TI gajinya segitu? Ya enggak lah.",
      },
      convo: {
        claim: "Screen time Gen Z rata-rata 7 jam sehari. **Pantesan anak kamu kerjaannya main HP mulu**, emang generasinya gitu.",
        response: "Rata-rata bukan berarti tiap anak segitu. **Ada yang 2 jam, ada yang 12 jam.**",
      },
      reveal: {
        body: "Kamu nyimpulin sifat **individu** dari **statistik kelompok**. Padahal rata-rata grup gak menjamin kondisi tiap anggotanya.",
      },
      insight: {
        title: "Yang sering dilupain",
        body: "Perbedaan **antar individu dalam satu kelompok** sering lebih besar dari perbedaan antar kelompoknya. Jadi jangan judge orang dari statistik grupnya.",
      },
      engagement: {
        title: "Pernah di-judge berdasarkan statistik kelompok kamu? 🌐",
        body: "Jurusan, generasi, atau asal daerah? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["hasty-generalization", "simpsons-paradox", "sampling-bias", "survivorship-bias"],
  };
